import { render, staticRenderFns } from "./GiveAwayFacilities.vue?vue&type=template&id=775d275f&scoped=true&"
import script from "./GiveAwayFacilities.vue?vue&type=script&lang=js&"
export * from "./GiveAwayFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d275f",
  null
  
)

export default component.exports